export const specialExpressionTypes = {
  '??': 0,
  '&&': 1,
  '||': 2,
  'array': 3,
  'cond': 4,
  '0_def': 5,
  'defined?': 6,
  '0_defn': 7,
  'block': 8,
  'doseq': 9,
  '0_fn': 10,
  'for': 11,
  'function': 12,
  'if': 13,
  'let': 14,
  'loop': 15,
  'object': 16,
  'recur': 17,
  'switch': 18,
  'throw': 19,
  'try': 20,
  'unless': 21,
} as const

export type SpecialExpressionTypes = typeof specialExpressionTypes
